module.exports = __webpack_public_path__ + "static/HamptonsHome-b1877322ab847e5d4b54b7a252c36045.jpg";